import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { HeaderComponent } from './common-components/header/header.component';
import { FooterComponent } from './common-components/footer/footer.component';


import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';


import { PageTitleComponent } from './common-components/page-title/page-title.component';
import { TableComponent } from './common-components/table/table.component';
import { SpinnerComponent } from './common-components/spinner/spinner.component';
import { vovSharedService } from './services/vov-shared.service';
import { ErrorComponent } from './common-components/error/error.component';



@NgModule({
    declarations: [
        HeaderComponent,
        FooterComponent,
        PageTitleComponent,
        TableComponent,
        SpinnerComponent,
        ErrorComponent,
    ],
    imports: [
        BrowserModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatProgressSpinnerModule,
        MatCheckboxModule

    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        PageTitleComponent,
        TableComponent,
        SpinnerComponent
    ],
    providers: [vovSharedService],
})
export class SharedModule { }
